module.exports = __webpack_public_path__ + "img/thumbnail_Markhor_m_normal.879ce7c1.png";